import { authActions } from "../slice/authSlice";
import axios from "axios";
import { toast } from "react-toastify";
import { PRODUCTION_API } from "../../config/api";
import "react-toastify/dist/ReactToastify.css";

const userApi = (path) => `${PRODUCTION_API}${path}`;

export const loginUser = (email, password) => {
  return async (dispatch) => {
    try {
      const response = await axios.post(userApi("/api/user/login"), {
        email: email.trim().toLowerCase(),
        password,
      });
      const payload = response.data;
      localStorage.setItem("userInfo", JSON.stringify([payload]));
      localStorage.setItem("token", JSON.stringify(payload.token));
      dispatch(authActions.login([payload]));
      return payload;
    } catch (error) {
      const backendMessage =
        error.response?.data?.error ||
        error.response?.data?.message ||
        "Login failed. Please try again.";
      toast.error(backendMessage);
      throw error;
    }
  };
};

export const logoutUser = (navigate) => {
  return (dispatch) => {
    dispatch(authActions.logout());
    localStorage.removeItem("userInfo");
    localStorage.removeItem("token");
    dispatch(authActions.login(null));
  };
};

export function registerUser(user) {
  return async (dispatch) => {
    try {
      const { data, status } = await axios.post(
        userApi("/api/user/signup"),
        user
      );
      dispatch(authActions.register(data.message));
      if (status === 200 || status === 201) {
        toast.success(data.message || "Account created successfully!");
        return { success: true };
      }
      toast.error(data.message || "Sign up failed.");
      return { success: false };
    } catch (error) {
      const status = error.response?.status;
      const rawData = error.response?.data;
      let message =
        rawData?.message ||
        rawData?.error ||
        (typeof rawData === "string" && !rawData.includes("<!DOCTYPE")
          ? rawData
          : null);

      if (!message) {
        if (status === 409) {
          message = "Email or username already exists!";
        } else       if (status === 422) {
          message = "Password must be between 8 and 20 characters.";
        } else if (status === 400 && rawData?.error === "Invalid phone number") {
          message = "Please enter a valid phone number (7-15 digits).";
        } else if (status === 400) {
          message = "Please fill in all required fields.";
        } else {
          message = "Sign up failed. Please try again.";
        }
      }

      if (message === "Invalid password") {
        message =
          "Password rejected by server. Deploy the updated backend or use 8-20 characters.";
      }

      toast.error(message);
      let field = null;
      if (status === 422 || message.includes("Password")) field = "password";
      else if (rawData?.error === "Invalid phone number" || message.includes("phone")) field = "phone";
      else if (status === 409 && message.includes("email")) field = "email";
      else if (status === 409 && message.includes("username")) field = "username";
      return { success: false, message, field };
    }
  };
}
